import styled from "styled-components";

export const Container = styled.div`
  font-size: 14px;
  display: flex;
`;

export const Link = styled.a`
  padding: 0.6em;
  color: black;
`;
